module.exports = __webpack_public_path__ + "4271f99725dd75796408b37d1c2ab6d8.png";